import get from 'lodash.get';

const getDefaultColorPaletteId = (state) =>
  get(state, 'ws.template.meta.customization.colorPalette', null);

export default getDefaultColorPaletteId;
